<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">Cambiar Contraseña</h2>
        <div class="row">
          <div class="col-md-6">
            <!-- <p class="round3">
              Al modificar su contraseña se le notificará a su correo y número
              de contacto.
            </p> -->
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-6 mt-3">
            <label class="form-label">Correo Institucional:</label>
            <input
              class="form-control fuente"
              v-model="state.formData.correo_electronico"
            />
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-label">Teléfono de Contacto:</label>
            <input
              class="form-control fuente"
              v-model="state.formData.telefono_movil"
            />
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-4 mt-3">
            <label class="form-label required">Contraseña Actual:</label>
            <input
              type="text"
              class="form-control fuente"
              ref="contrasena_actual"
              id="contrasena_actual"
              v-model="state.formData.contrasena_actual"
            />
            <!-- <div
              class="input-errors"
              v-for="error of v$.formData.contrasena.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Contraseña requerida</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener al menos 8 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Máximo aceptado de 20 caracteres</span
              >
            </div> -->
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Nueva Contraseña:</label>
            <input
              type="password"
              class="form-control fuente"
              ref="contrasena"
              id="contrasena"
              v-model="state.formData.contrasena"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.contrasena.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Contraseña requerida</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener al menos 8 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Máximo aceptado de 20 caracteres</span
              >
            </div>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-label required">Confirme Contraseña:</label>
            <input
              type="password"
              class="form-control fuente"
              ref="contrasena_confirmacion"
              id="contrasena_confirmacion"
              v-model="state.formData.contrasena_confirmacion"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.contrasena_confirmacion.$errors"
              :key="error.$uid"
            >
              <!-- {{ error }} -->
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Contraseña requerida</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener al menos 8 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Máximo aceptado de 20 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'sameAsPassword'"
                >Debe ser la misma contraseña</span
              >
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button
              type="button"
              class="btn btn-danger px-4 mx-3"
              @click="back"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-success px-4 mx-3"
              @click="submitButton"
            >
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, sameAs } from "@vuelidate/validators";
import user from "@/user/composables/useUser";
export default defineComponent({
  name: "myProfile",
  components: {},
  setup() {
    const router = useRouter();
    const contrasena_actual = ref("");
    const contrasena = ref(null);
    const contrasena_confirmacion = ref(null);

    let id_usuario = JSON.parse(localStorage.getItem("user")).usuario;
    id_usuario = id_usuario.split(/[(,]+/);
    id_usuario = id_usuario[1];

    const state = reactive({
      formData: {
        id_persona: "",
        id_usuario: "",
        nombre_usuario: "",
        telefono_movil: "",
        correo_electronico: "",
        contrasena: "",
        contrasena_confirmacion: "",
        contrasena_actual: "",
      },
    });

    const { infoUser, updatePassword, infoPasswordUser } = user();

    const setUserInformation = async () => {
      const { data } = await infoUser(id_usuario);
      state.formData.id_persona = data.id_persona;
      state.formData.id_usuario = data.id_usuario;
      state.formData.nombre_usuario = data.nombre_usuario;
      state.formData.correo_electronico = data.correo_electronico;
      state.formData.telefono_movil = data.telefono_movil;
      let pass = await infoPasswordUser(data.id_usuario);
      contrasena_actual.value = pass.data.data;
    };

    onMounted(() => {
      setUserInformation();
    });

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });

    const rules = computed(() => {
      return {
        formData: {
          contrasena: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(20),
          },
          contrasena_confirmacion: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(20),
            sameAsPassword: sameAs(state.formData.contrasena),
          },
        },
      };
    });
    const v$ = useVuelidate(rules, state);

    // BOTON CANCELAR
    const back = () => {
      router.push({ name: "dashboard" });
    };

    // BOTON REGISTRAR
    const submitButton = async () => {
      v$.value.$validate();
      if (!v$.value.$error) {
        // PARSEO DE VARIABLES DEL FORMULARIO
        state.formData.contrasena = state.formData.contrasena.replace(
          /['`"]+/g,
          ""
        );
        if (contrasena_actual.value !== state.formData.contrasena_actual) {
          Toast.fire({
            icon: "error",
            title: "Su contraseña actual no es la correcta",
          });
        } else {
          // REDIRECCIONAMIENTO
          let data = await updatePassword(state.formData);
          // ALERTAS
          if (data.data) {
            Toast.fire({
              icon: "success",
              title: data.data.message,
            });
            router.push({ name: "sign-in" });
          } else {
            Toast.fire({
              icon: "error",
              title: data.message.response.data,
            });
          }
        }
      } else {
        // DEVUELVE LOS CAMPOS QUE FALTAN
        const expr = v$.value.$errors[0].$property;
        switch (expr) {
          case "contrasena":
            contrasena.value.focus();
            break;
          case "contrasena_confirmacion":
            contrasena_confirmacion.value.focus();
            break;
        }
      }
    };

    return {
      state,
      v$,

      submitButton,
      back,

      contrasena,
      contrasena_confirmacion,
    };
  },
});
</script>

<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
